<template>
  <layout-breadcrumb-cartao
    cartaoCustom
    titulo="Detalhes do arquivo"
    :breadcrumb="bread"
    :iconeSvg="ValidacaoSvg"
  >
    <div slot="cartao">
      <unicom-linha>
        <unicom-coluna sm="12" md="12" lg="4">
          <CardInformacoes
            @observacoes="abrirObservacoes"
            :loading="loadingInformacoes"
            :objetoInformacoes="objetoInformacoes"
          />
        </unicom-coluna>
        <unicom-coluna sm="12" md="12" lg="8">
          <TabelaErro
            ref="tabelaErro"
            @exportar-relatorio="exportarRelatorio"
            @check="checkboxErros = $event"
            @quantidadeTotal="quantidadeTotal = $event"
            @mapValoresCheck="mapValoresCheck = $event"
            :statusArquivo="objetoInformacoes.status"
            :idValidacao="idAtual"
          />
        </unicom-coluna>
        <unicom-coluna
          sm="12"
          class="pt-3"
          v-if="mostrarAcoes && !loadingInformacoes"
        >
          <unicom-linha justificarItem="end">
            <unicom-coluna
              sm="12"
              md="auto"
              :order="$breakpoint.smAndDown ? 1 : 0"
              :class="$breakpoint.smAndDown ? 'mt-2' : ''"
            >
              <unicom-botao
                @click="desconsiderarErros"
                :largura="216"
                tipo="secundario"
                :desabilitado="desabilitarBotaoDesconsiderarErros"
                :bloco="$breakpoint.smAndDown"
              >
                DESCONSIDERAR ERROS
              </unicom-botao>
            </unicom-coluna>
            <unicom-coluna
              sm="12"
              md="auto"
              :order="$breakpoint.smAndDown ? 1 : 0"
              :class="$breakpoint.smAndDown ? 'mt-2' : ''"
              v-if="mostrarBotaoReprovar"
            >
              <unicom-botao
                @click="mostrarModalReprovar = true"
                :largura="216"
                tipo="secundario"
                :desabilitado="!habilitarBotoesRealizarAnalise"
                :bloco="$breakpoint.smAndDown"
              >
                REPROVAR
              </unicom-botao>
            </unicom-coluna>
            <unicom-coluna sm="12" md="auto">
              <unicom-botao
                @click="mostrarModalAprovar = true"
                :largura="216"
                tipo="primario"
                :desabilitado="!habilitarBotoesRealizarAnalise"
                :bloco="$breakpoint.smAndDown"
              >
                APROVAR
              </unicom-botao>
            </unicom-coluna>
            <unicom-coluna sm="12" md="auto">
              <unicom-botao
                @click="assumirAnalise"
                :largura="216"
                tipo="primario"
                :desabilitado="!habilitarBotaoAssumirAnalise"
                :bloco="$breakpoint.smAndDown"
              >
                Assumir Análise
              </unicom-botao>
            </unicom-coluna>
          </unicom-linha>
        </unicom-coluna>
      </unicom-linha>
      <ModalReprovar
        v-model="mostrarModalReprovar"
        :possuiAlgumErroConsiderado="possuiAlgumErroConsiderado"
        @botao-confirmar="confirmarReprovar"
      />
      <ModalAprovar
        v-model="mostrarModalAprovar"
        :possuiAlgumErroConsiderado="possuiAlgumErroConsiderado"
        @botao-confirmar="confirmarAprovar"
      />
      <MenuObservacao
        :quantidadeObservacoes="quantidadeObservacoes"
        v-model="mostrarMenuObservacao"
      />
      <ModalConfirmarEdicao
        v-model="mostrarModalEdicao"
        @botao-confirmar="$store.commit()"
      />
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
/* eslint-disable */
import ValidacaoDetalheMixin from "./shared/ValidacaoDetalheMixin";
import TabelaErro from "./shared/componentes/TabelaErro/TabelaErro";
import CardInformacoes from "./shared/componentes/CardInformacoes";
import ModalReprovar from "./shared/componentes/ModalReprovar";
import ModalAprovar from "./shared/componentes/ModalAprovar";
import { enumStatusValidacaoNome } from "../../shared/helpers/Enum";

// OBSERVAÇÕES
import ModalConfirmarEdicao from "../AdministracaoDetalhe/shared/componentes/Observacoes/ModalConfirmarEdicao";
import MenuObservacao from "../AdministracaoDetalhe/shared/componentes/Observacoes/MenuObservacao";

export default {
  mixins: [ValidacaoDetalheMixin],
  components: {
    TabelaErro,
    CardInformacoes,
    ModalAprovar,
    ModalReprovar,
    ModalConfirmarEdicao,
    MenuObservacao
  },
  data() {
    return {
      arrTexto: [],
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Validação", url: "/validacao" },
        { titulo: "Detalhes" }
      ],
      mostrarMenuObservacao: false
    };
  },
  computed: {
    /**
     * Retorna true se o status do arquivo for diferente de APROVADO
     * @return {Boolean}
     */
    mostrarAcoes() {
      if (this.objetoInformacoes.status === undefined) return false;
      return (
        enumStatusValidacaoNome[this.objetoInformacoes.status] ===
        enumStatusValidacaoNome.PENDENTE
      );
    },
    quantidadeObservacoes() {
      return this.$store.getters.getTotalObservacao;
    },
    mostrarModalEdicao: {
      set(value) {
        this.$store.commit("setMostrarModalEdicao", value);
      },
      get() {
        return this.$store.getters.getMostrarModalEdicao;
      }
    }
    ,
    desabilitarBotaoDesconsiderarErros() {
      return this.checkboxErros.length < 1 || !this.habilitarBotoesRealizarAnalise;
    }
  }
};
</script>
